import React, { FunctionComponent } from "react";
import { Link } from "gatsby";
import { Layout } from "../components/layout";
import { PageHeader } from "../components/pageHeader";
import { SEO } from "../components/seo";
import { TOPIC_ORDER, TOPICS } from "../topics";
import avatar from "../../static/logo.png";

export const About: FunctionComponent = () => (
  <>
    <SEO title="About" image="/logo.png" />
    <Layout>
      <PageHeader title="About" deck="A maker's notebook by Nahuel Taibo." />
      <div className="flex max-w-prose flex-col gap-10 px-gutter-sm pb-14 md:px-gutter">
        <div className="flex items-center gap-4">
          <img
            src={avatar}
            alt="Nahuel Taibo"
            className="h-16 w-16 rounded-full border-2 border-ink object-cover"
          />
          <p className="text-prose-sm md:text-prose">
            My adventures as a Maker and Software developer. I write up what I
            build, in four topics:
          </p>
        </div>
        <ul className="flex flex-col gap-6">
          {TOPIC_ORDER.map((key) => (
            <li
              key={key}
              className={`border-t-[6px] pt-3.5 ${TOPICS[key].borderClass}`}
            >
              <Link
                to={TOPICS[key].href}
                className="font-display text-h4 font-extrabold hover:text-spark"
              >
                {TOPICS[key].name}
              </Link>
              <p className="mt-1 text-body-sm text-body-2">
                {TOPICS[key].description}
              </p>
            </li>
          ))}
        </ul>
        <div>
          <Link to="/contact" className="btn-primary">
            Get in touch
          </Link>
        </div>
      </div>
    </Layout>
  </>
);

export default About;
